import { Component, OnInit, ViewEncapsulation, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy, inject, output, input, linkedSignal } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Dir } from '@angular/cdk/bidi';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./color-picker.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormsModule, Dir]
})
export class ColorPickerComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);


  readonly ngModelInput = input('', {alias: 'ngModel'});
  readonly ngModel = linkedSignal(() => this.ngModelInput());
  readonly id = input('');
  readonly ngClass = input({});
  readonly class = input('');
  readonly valueInput = input('', {alias: 'value'});
  readonly value = linkedSignal(() => this.valueInput());
  readonly pickerClass = input('');
  readonly ngModelChange = output<any>();
  // eslint-disable-next-line @angular-eslint/no-output-native -- renaming the output would change every binding to it
  readonly change = output<any>();
  readonly extraColorsInput = input([], {alias: 'extraColors'});
  readonly extraColors = linkedSignal(() => this.extraColorsInput());
  openPicker = false;
  inputHex = '';
  defaultColors = ['#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC', '#41A85F',
    '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#000000', '#F7DA64',
    '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FFFFFF', '#FAC51C',
    '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8',
  ];

  preventClick = false;
  initialized = false;

  constructor() {
    this.closePicker = this.closePicker.bind(this);
    this.openColorPicker = this.openColorPicker.bind(this);
  }

  ngOnInit(): void {
    this.inputHex = '';
    this.ngModel.set(this.value());
    this.extraColors.set(this.extraColors() || []);
  }

  closePicker(): void {
    if (this.openPicker && !this.preventClick) {
      this.openPicker = false;
      this.initialized = false;

      this.cdr.detectChanges();
      document.onclick = () => {};
    }
  }

  setPreventClick(bool): void {
    this.preventClick = bool;
  }

  customColor(): void {
    if (this.inputHex && this.inputHex.trim() && this.inputHex.includes('#')) {
      this.setColor(this.inputHex.trim());
      this.cdr.detectChanges();
    }
  }

  setColor(color) {
    this.ngModel.set('#' + color.replace('#', ''));
    this.value.set('#' + color.replace('#', ''));
    this.change.emit({target: {value: color}});
    this.ngModelChange.emit(this.ngModel());
    this.openPicker = false;
  }

  getFontColor(): string {
    let hexcolor = this.ngModel() || this.value() || '#ffffff';
    hexcolor = hexcolor.replace('#', '');
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? '#000000' : '#ffffff';
  }

  openColorPicker(): void {
    this.openPicker = true;
    setTimeout(() => {
      if (!this.initialized) {
        document.onclick = this.closePicker;
        this.initialized = true;
      }
    });
  }
}
